// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2BGuG","savePackageButton":"ClientWallet_savePackageButton__1SQtU"};